import React from 'react'
import merge from 'lodash/merge'
import { SkeletonProps } from './Skeleton.types'

const Skeleton: React.FC<SkeletonProps> = ({
    color = ['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0.5)', 'rgba(255, 255, 255, 0)', '#f5f5f5'],
    size = [],
    style,
    type,
}) => {
    const defaultBaseColor = '#fff'
    const defaultHighlightColor = '#000'

    // const background = `linear-gradient(to right, ${color[0]}, ${color[1]} 50%, ${color[2]} 80%), ${color[3]};`
    // const background = 'linear-gradient(to right, blue, green, red, blue)'

    const _style = merge(style, {
        width: size[0] || '120px',
        height: size[1] || '20px',
        marginBottom: size[2] || '10px',
    })

    const classnames = () => {
        const c = ['r-skeleton-container']

        if (type) {
            c.push('r-skeleton-' + type)
        }

        return c.join(' ')
    }

    return (
        <div style={_style} data-testid='Skeleton' className={classnames()}>
            <div className={'r-skeleton-motion'} />
        </div>
    )
}

export default Skeleton
